import { render, staticRenderFns } from "./RadioBox.vue?vue&type=template&id=af846044&scoped=true&"
import script from "./RadioBox.vue?vue&type=script&lang=js&"
export * from "./RadioBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af846044",
  null
  
)

export default component.exports